/** Admit bookmarked salary sorts without changing any other listing filters. */
export function normalizeRetiredJobportalSort<
  T extends { orderBy?: string | null; order?: string | null },
>(filter: T) {
  if (
    filter.orderBy !== 'salary' ||
    (filter.order != null && filter.order !== 'asc' && filter.order !== 'desc')
  ) {
    return filter;
  }

  return { ...filter, orderBy: 'created_at' as const, order: 'desc' as const };
}

/** Offers use publication dates; keep old bookmarks and other model sorts independent. */
export function normalizeJobOfferSort<
  T extends { orderBy?: string | null; order?: string | null },
>(filter: T) {
  const normalized = normalizeRetiredJobportalSort(filter);
  return {
    ...normalized,
    orderBy:
      !normalized.orderBy || normalized.orderBy === 'created_at'
        ? ('published_at' as const)
        : normalized.orderBy,
    order: normalized.order || ('desc' as const),
  };
}
